import React, { forwardRef, useState } from "react";
import { ReactComponent as EyeOpenIcon } from "../../../icons/eye.svg";
import { ReactComponent as EyeOffIcon } from "../../../icons/eyeOff.svg";
import { IconManager } from "../IconManager/IconManager";
import { IconSizeEnum } from "../../../types/AppTypes";
import Input, { InputProps } from "../Input/Input";

interface PasswordInputProps extends Omit<InputProps, "onChange"> {
  onChange?: (value: string) => void;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ onChange, ...props }, ref) => {
    const [inputType, setInputType] = useState<"text" | "password">("password");

    return (
      <Input
        ref={ref}
        onChange={(value) => {
          if (onChange) {
            onChange(value);
          }
        }}
        {...props}
        allowClear
        type={inputType}
        endIcon={
          inputType === "password" ? (
            <IconManager
              size={IconSizeEnum.SMALL}
              onClick={() => setInputType("text")}
            >
              <EyeOpenIcon />
            </IconManager>
          ) : (
            <IconManager
              size={IconSizeEnum.SMALL}
              onClick={() => setInputType("password")}
            >
              <EyeOffIcon />
            </IconManager>
          )
        }
      />
    );
  },
);

export default PasswordInput;
